export function parseBp(bpString) {
  if (bpString == null || bpString === '') {
    return { systolic: null, diastolic: null };
  }

  const text = String(bpString).trim();
  const match = text.match(/^(\d+(?:\.\d+)?)\s*(?:\/|-)\s*(\d+(?:\.\d+)?)$/);
  if (match) {
    return {
      systolic: Number(match[1]),
      diastolic: Number(match[2]),
    };
  }

  const single = Number(text);
  if (!Number.isNaN(single)) {
    return { systolic: single, diastolic: null };
  }

  return { systolic: null, diastolic: null };
}

/** Strip trailing % so UI unit "%" is not doubled (e.g. "93%" → "93"). */
export function stripO2SatPercent(value) {
  if (value == null || value === '') return value;
  if (typeof value === 'number') return value;
  return String(value).replace(/%+\s*$/g, '').trim();
}
